import PropTypes from "prop-types"
import React from "react"
import { withRouter } from "react-router-dom"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.svg"
import logosm from "../../assets/images/favicon.ico"

const SideBar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logosm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logosm} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="48" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent currentUser={props.currentUser} />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

SideBar.propTypes = {
  type: PropTypes.string,
}

export default withRouter(SideBar)
